import React, { useState, useEffect } from 'react';
import axiosInstance from '../utils/axiosInstance';
import {
    FaClock, FaCheckCircle, FaTimesCircle, FaFire,
    FaHistory, FaChartBar, FaUserShield
} from 'react-icons/fa';
import './css/Dashboard.css';
import { toast, Toaster } from 'react-hot-toast';

const Dashboard = () => {
    const [requests, setRequests] = useState([]);
    const [bonusMap, setBonusMap] = useState({});
    const [loading, setLoading] = useState(true);
    const [isSystemActive, setIsSystemActive] = useState(true);
     const [loadingStatus, setLoadingStatus] = useState(true);

    const fetchSystemStatus = () => {
        axiosInstance.get('/siteSettings')
            .then(response => {
                // Senin sayfandaki "bonusRequestsEnabled" değerini alıyoruz
                setIsSystemActive(response.data.bonusRequestsEnabled);
            })
            .catch(error => {
                console.error("Sistem durumu çekilemedi:", error);
            })
            .finally(() => {
                setLoadingStatus(false);
            });
    };

    const fetchDashboardData = async () => {
        try {
            const [pendingRes, approvedRes, rejectedRes, bonusesRes] = await Promise.all([
                axiosInstance.get('/request'),
                axiosInstance.get('/request/approved'),
                axiosInstance.get('/request/rejected'),
                axiosInstance.get('/bonus/all')
            ]);

            const bMap = {};
            if (bonusesRes.data) {
                bonusesRes.data.forEach(b => { bMap[b.bonusType || b._id] = b.name; });
            }
            setBonusMap(bMap);

            const allCombined = [
                ...(pendingRes.data || []),
                ...(approvedRes.data || []),
                ...(rejectedRes.data || [])
            ];
            setRequests(allCombined);
        } catch (err) {
            console.error("Hata:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDashboardData();
        fetchSystemStatus();
        const intervalDashboard = setInterval(fetchDashboardData, 30000);
        const intervalSystemStatus = setInterval(fetchSystemStatus, 20000);
        return () => {
            clearInterval(intervalDashboard);
            clearInterval(intervalSystemStatus);
        };
    }, []);

    

    const handleCopy = (text) => {
        if (!text) return;
        navigator.clipboard.writeText(text);
        toast.success('Kopyalandı!', { style: { background: '#1e2024', color: '#fff' } });
    };

    const stats = {
        pending: requests.filter(r => r.status === 'pending').length,
        approved: requests.filter(r => r.status === 'approved').length,
        rejected: requests.filter(r => r.status === 'rejected').length
    };

    const assignmentData = requests.reduce((acc, curr) => {
        if (curr.assignedTo) acc[curr.assignedTo] = (acc[curr.assignedTo] || 0) + 1;
        return acc;
    }, {});

    const sortedAssignments = Object.entries(assignmentData)
        .map(([name, count]) => ({ name, count }))
        .sort((a, b) => b.count - a.count);

    const totalAssigned = sortedAssignments.reduce((sum, item) => sum + item.count, 0);

    // Popüler bonusu bulma mantığı
    const popularBonusCode = requests.length > 0 ?
        Object.entries(requests.reduce((acc, curr) => {
            acc[curr.bonusType] = (acc[curr.bonusType] || 0) + 1;
            return acc;
        }, {})).sort((a, b) => b[1] - a[1])[0]?.[0] : null;

    // Eslint hatasını bitiren tanım:
    const popularBonusName = bonusMap[popularBonusCode] || popularBonusCode || "Veri Yok";

    return (
        <div className="data-page-container">
            <Toaster position="top-right" />

            <header className="header-card">
                <div className="title-with-icon">
                    <FaUserShield className="title-icon" />
                    <div>
                        <h2>Dashboard </h2>
                    </div>
                </div>
            </header>

            <div className="stats-grid-dashboard">
                {[
                    {
                        label: 'Bekleyen Talep',
                        val: stats.pending,
                        icon: <FaClock />,
                        cls: 'b-blue'
                    },
                    {
                        label: 'Toplam Onay',
                        val: stats.approved,
                        icon: <FaCheckCircle />,
                        cls: 'b-green'
                    },
                    {
                        label: 'Toplam Red',
                        val: stats.rejected,
                        icon: <FaTimesCircle />,
                        cls: 'b-red'
                    },
                    {
                        label: 'En Popüler',
                        val: popularBonusName || "Yükleniyor...",
                        icon: <FaFire />,
                        cls: 'b-orange'
                    }
                ].map((item, index) => (
                    <div key={index} className={`stat-premium-card ${item.cls}`}>
                        <div className="stat-content-centered">
                            {/* Üst Satır: İkon ve Başlık */}
                            <div className="stat-header-mini">
                                <div className="stat-icon-box">
                                    {item.icon}
                                </div>
                                <span className="stat-label-modern">{item.label}</span>
                            </div>

                            {/* Alt Satır: Büyük Değer */}
                            <h3 className="stat-value-large" style={item.cls === 'b-orange' ? { fontSize: '0.9rem', color: '#fbbf24', textTransform: 'uppercase' } : {}}>
                                {item.val}
                            </h3>
                        </div>

                        {/* Arka Plan Dekoratif İkon (Canlılık katması için) */}
                        <div style={{
                            position: 'absolute',
                            right: '-10px',
                            bottom: '-10px',
                            opacity: '0.04',
                            fontSize: '5rem',
                            transform: 'rotate(-15deg)',
                            color: 'white',
                            pointerEvents: 'none'
                        }}>
                            {item.icon}
                        </div>
                    </div>
                ))}
            </div>

            <div className="dashboard-main-grid">
                {/* SOL TARAF: Son 8 Hareket */}
                <div className="content-card-modern">
                    <div className="flex-between" style={{ marginBottom: '20px' }}>
                        <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '10px', fontSize: '1.1rem' }}>
                            <FaHistory style={{ color: 'var(--primary)' }} /> Son 8 Talep
                        </h3>

                    </div>

                    <div className="list-container">
                        {requests
                            .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
                            .slice(0, 8)
                            .map((req) => (
                                <div key={req._id} className="modern-log-row-compact">
                                    <div className={`status-indicator-bar bg-${req.status}`}></div>

                                    {/* 1. Kullanıcı */}
                                    <div className="col-user" onClick={() => handleCopy(req.username)} style={{ cursor: 'pointer' }}>
                                        <span className="user-avatar-text">{req.username}</span>
                                    </div>

                                    {/* 2. Durum */}
                                    <div className="col-status-pill">
                                        <span className={`status-pill pill-${req.status}`}>
                                            {req.status === 'approved' ? 'Onay' : req.status === 'rejected' ? 'Red' : 'Bekliyor'}
                                        </span>
                                    </div>

                                    {/* 3. Bonus Bilgisi */}
                                    <div className="col-bonus-info">
                                        <span className="bonus-title">{bonusMap[req.bonusType] || req.bonusType}</span>
                                    </div>

                                    {/* 4. MERKEZİ NOT ALANI (Yeni) */}
                                    <div className="col-reason-tag">
                                        {(req.rejectReason || req.adminNote) ? (
                                            <span
                                                className="reason-badge"
                                                onClick={() => handleCopy(req.rejectReason || req.adminNote)}
                                                title={req.rejectReason || req.adminNote}
                                            >
                                                {req.rejectReason || req.adminNote}
                                            </span>
                                        ) : (
                                            <span style={{ color: 'rgba(255,255,255,0.03)', fontSize: '0.8rem' }}>—</span>
                                        )}
                                    </div>

                                    {/* 5. Saat (En Sağda) */}
                                    <div className="col-time-modern">
                                        {new Date(req.updatedAt).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>

                {/* SAĞ TARAF: Atama Dağılımı */}
                <div className="content-card-modern">
                    <div className="flex-between" style={{ marginBottom: '15px' }}>
                        <h3 style={{ margin: 0, fontSize: '1rem' }}><FaChartBar /> Dağılım</h3>
                    </div>

                    <div className="list-container">
                        {sortedAssignments.slice(0, 8).map((op, i) => (
                            <div key={i} className="operator-card-mini">
                                <div className="flex-between">
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <span style={{ fontWeight: '700', fontSize: '0.85rem' }}>{op.name}</span>
                                        <span style={{ color: 'white', fontSize: '0.7rem' }}>{op.count} Talep</span>
                                    </div>
                                    <span style={{ color: 'var(--primary)', fontWeight: '800', fontSize: '0.8rem' }}>
                                        %{totalAssigned > 0 ? ((op.count / totalAssigned) * 100).toFixed(0) : 0}
                                    </span>
                                </div>
                                <div className="progress-track">
                                    <div className="progress-fill" style={{ width: `${totalAssigned > 0 ? (op.count / totalAssigned) * 100 : 0}%` }}></div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;